<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 客渠管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>产商信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.shortName" placeholder="产商简称" class="handle-input mr10"></el-input>
				&nbsp;&nbsp;
				<el-input v-model="query.brand" placeholder="品牌" class="handle-input mr10"></el-input>
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				<el-button type="primary" icon="el-icon-download" @click="handleExport" v-if = "controll['export']">导出</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="shortName" label="简称"></el-table-column>
				<el-table-column prop="brand" label="品牌"></el-table-column>
				<el-table-column prop="contact" label="联系人"></el-table-column>
				<el-table-column prop="tel" label="联系电话"></el-table-column>
				<el-table-column prop="website" label="网址"></el-table-column>
				<el-table-column prop="logo" label="logo" align="center">
					<template slot-scope="scope" v-if="scope.row.logo">
                        <el-image
                            class="table-td-thumb"
                            :src="imgPrefix+scope.row.logo"
                        ></el-image>
                    </template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if = "controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if = "controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if = "controll['delete-batch']"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if = "controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="40%">
            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
				<el-form-item label="名称" prop="name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
				<el-form-item label="简称" prop="shortName">
                    <el-input v-model="form.shortName"></el-input>
                </el-form-item>
				<el-form-item label="品牌" prop="brand">
                    <el-input v-model="form.brand"></el-input>
                </el-form-item>
				<el-form-item label="联系人" prop="contact">
                    <el-input v-model="form.contact"></el-input>
                </el-form-item>
				<el-form-item label="联系电话" prop="tel">
                    <el-input v-model="form.tel"></el-input>
                </el-form-item>
				<el-form-item label="网址" prop="website">
                    <el-input v-model="form.website"></el-input>
                </el-form-item>
				<el-form-item label="LOGO" prop="logo">
					<el-upload
						class="upload-demo"
						multiple = false
						:before-upload="beforeUpload"
						:action= "uploadUrl"
						:on-success="uploadSuccess"
						:on-remove="handleRemove"
						:file-list="fileList"
						accept=".png,.jpg"
						list-type="picture">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
					</el-upload>
				</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
			
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchManufacturerData, saveManufacturer, deleteManufacturer, getManufacturer, removeImg, exportManufacturer } from '../../../api/index';
export default {
    name: 'manufacturer',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
			imgPrefix:"/image",
			uploadUrl : "/image/upload/10",
			fileList:[],
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			title:"",
			rules: {
                name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
                shortName: [{ required: true, message: '简称不能为空', trigger: 'blur' }],
				brand: [{ required: true, message: '品牌不能为空', trigger: 'blur' }]
            },
			controll:{}
        };
    },
    created() {
		this.controll = getControll("manufacturer");
		let ckey = localStorage.getItem('ms_ckey');
		this.uploadUrl = "/image/upload/" + ckey + "/10";
        this.getData();
    },
    methods: {
		//文件上传
		uploadSuccess(response, file, fileList) {
			this.form.logo = response.data;
		},
		//删除图片
		handleRemove(file, fileList) {
			if (!this.form.logo) {
				return;
			}
			removeImg([this.form.logo]).then(res => {
				if (res.code == 0 ) {
					this.$message.success("删除图片成功");
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchManufacturerData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteManufacturer([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteManufacturer(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.fileList = [];
			this.title = "添加新纪录";
			this.isDisabled = false;
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
			this.fileList = [];
            this.idx = index;
            //this.form = row;
			this.title = "编辑";
			this.isDisabled = true;
			getManufacturer(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					let json = {};
					json['url'] = this.imgPrefix + res.data.logo;
					this.fileList.push(json);
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveManufacturer(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							//this.$message.success(`修改第 ${this.idx + 1} 行成功`);
							if (typeof(this.form.id) == "undefined") {
								this.getData();
							} else {
								this.$set(this.tableData, this.idx, this.form);
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		handleExport() {
			exportManufacturer().then(res => {
				if (res.code == 0) {
					this.$message.success(`生成XML数据成功！`);
					var linkTag = document.createElement("a");
					linkTag.href = "/blob/export/download-xml?key=" + res.data;			
					linkTag.click();
					linkTag.remove();
				} else {
					this.$message.error(`导出失败！` + res.message);
				}
			})
		},
		beforeUpload(file){
			let limit = file.size / 1024 < 1024;
			if (!limit) {
			  this.$message.error('上传文件大小不能超过 1M');
			  return false;
			}
			return true;
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
